// extracted by mini-css-extract-plugin
module.exports = {"sign-out-text":"sign-out-text__2D7Ay"};